import create from 'zustand'

import config from '@common/configs'
import AlgorandNetwork from '@providers/AlgorandNetwork'
import EthereumNetwork from '@providers/EthereumNetwork'
import { NetworkManager } from '@providers/NetworkManager'
import PolygonNetwork from '@providers/PolygonNetwork'
import { IMetadataProperties } from '@types'

export interface INetworkWalletsData {
    walletProvider?: EthereumNetwork | AlgorandNetwork | PolygonNetwork
    setWalletProvider: (value: EthereumNetwork | AlgorandNetwork | PolygonNetwork) => void
    isLoadingContext: boolean
    setIsLoadingContext: (value: boolean) => void
    estimatedGasFee: string
    setEstimatedGasFee: (value: string) => void
    estimatedTotalCost: string
    setEstimatedTotalCost: (value: string) => void
    mintResults: Record<string, unknown>[]
    setMintResults: (mintResult: Record<string, unknown>[]) => void
    metadataResults: IMetadataProperties[]
    setMetadataResults: (metadataResult: IMetadataProperties[]) => void

    // FROM METAMASK | Algorand
    balance: string
    setBalance: (value: string) => void
    isConnected: boolean
    setIsConnected: (value: boolean) => void
    loadingMessage: string
    setLoadingMessage: (value: string) => void
    suggestedGasFees: string
    setSuggestedGasFees: (value: string) => void
    shouldEstimateGas: boolean
    setShouldEstimateGas: (value: boolean) => void
    onMintGasFees: string
    setOnMintGasFees: (value: string) => void
    truncatedAddress: string
    setTruncatedAddress: (value: string) => void
    truncatedContractAddress: string
    setTruncatedContractAddress: (value: string) => void
    currentWalletAddress?: string
    setCurrentWalletAddress: (value: string | undefined) => void
    reset: () => void

    networkManager: NetworkManager
}

const initialState = {
    walletProvider: undefined,
    isLoadingContext: false,
    estimatedGasFee: '0',
    estimatedTotalCost: '0',
    mintResults: [],
    metadataResults: [],
    balance: '0',
    isConnected: false,
    loadingMessage: 'network.wallet.wait',
    suggestedGasFees: '0',
    shouldEstimateGas: false,
    onMintGasFees: '0',
    truncatedAddress: '',
    truncatedContractAddress: '',
    currentWalletAddress: '',
    networkManager: new NetworkManager(config),
}

const useStore = create<INetworkWalletsData>(set => ({
    ...initialState,
    setWalletProvider: value => set(() => ({ walletProvider: value })),
    setIsLoadingContext: value => set(() => ({ isLoadingContext: value })),
    setEstimatedGasFee: value => set(() => ({ estimatedGasFee: value })),
    setEstimatedTotalCost: value => set(() => ({ estimatedTotalCost: value })),
    setMintResults: value => set(() => ({ mintResults: value })),
    setMetadataResults: value => set(() => ({ metadataResults: value })),
    setBalance: value => set(() => ({ balance: value })),
    setIsConnected: value => set(() => ({ isConnected: value })),
    setLoadingMessage: value => set(() => ({ loadingMessage: value })),
    setSuggestedGasFees: value => set(() => ({ suggestedGasFees: value })),
    setShouldEstimateGas: value => set(() => ({ shouldEstimateGas: value })),
    setOnMintGasFees: value => set(() => ({ onMintGasFees: value })),
    setTruncatedAddress: value => set(() => ({ truncatedAddress: value })),
    setTruncatedContractAddress: value => set(() => ({ truncatedContractAddress: value })),
    setCurrentWalletAddress: value => set(() => ({ currentWalletAddress: value })),
    reset: () => {
        set({ ...initialState })
    },
}))
export default useStore
